'use client';
import { useState, useEffect, Suspense } from 'react';

let isVerifying = false;

function LoginContent() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [statusMsg, setStatusMsg] = useState('');
  const [isSent, setIsSent] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  
  const [isHoverSubmit, setIsHoverSubmit] = useState(false);
  const [isHoverOk, setIsHoverOk] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token && !isVerifying) {
      isVerifying = true;
      verifyMagicLink(token);
    }
  }, []);

  const verifyMagicLink = async (token: string) => {
    setLoading(true);
    setStatusMsg('認証サーバーと通信中...');
    try {
      const res = await fetch(`/api/auth/verify?token=${token}`);
      if (res.ok) {
        const user = await res.json();
        localStorage.setItem('user', JSON.stringify(user));
        if (user.session) localStorage.setItem('token', user.session);
        window.location.href = (user.tenantId === 'admin-tenant') ? '/ops/tenants' : '/home';
      } else {
        alert('認証に失敗しました。リンクが古いか、既に使用されています。');
        setStatusMsg('');
        window.history.replaceState({}, '', '/login');
      }
    } catch (error) {
      console.error('Fetch Error:', error);
      setStatusMsg('');
    } finally {
      setLoading(false);
    }
  };

  const handleLoginRequest = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setStatusMsg('メール送信中...');
    setErrorMsg('');

    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) {
        let msg = 'サーバーとの通信に失敗しました。';
        try {
          const data = await res.json();
          msg = data.message || msg;
        } catch(e) {}
        
        if (res.status === 404) msg = '登録されていないアドレスです。';
        else if (res.status === 500) msg = 'メール送信に失敗しました。';
        else if (res.status === 400) msg = '正しいメールアドレスを入力してください。';
        
        setErrorMsg(msg);
      } else {
        setIsSent(true);
      }
    } catch (error) {
      setErrorMsg('通信エラーが発生しました。');
    } finally {
      setLoading(false);
      setStatusMsg('');
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <div style={formStyle}>
<h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>
  <img src="/logo.png" alt="AutoXpress" style={{ height: '48px', width: 'auto', margin: '0 auto' }} />
</h2>
        {statusMsg ? (
          <div style={{ textAlign: 'center', padding: '1rem' }}>
            <p style={{ color: '#3182ce', fontWeight: 'bold' }}>{statusMsg}</p>
          </div>
        ) : isSent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#3182ce" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>メールを送信しました</p>
            <p style={{ fontSize: '0.9rem', color: '#666', lineHeight: '1.6' }}>
              メール内のリンクをクリックしてログインしてください。
            </p>
            <button
              onClick={() => setIsSent(false)}
              onMouseEnter={() => setIsHoverOk(true)}
              onMouseLeave={() => setIsHoverOk(false)}
              style={{ 
                ...buttonStyle, 
                backgroundColor: isHoverOk ? '#e2e8f0' : '#edf2f7', 
                color: '#4a5568', 
                marginTop: '1.5rem',
                transition: 'background-color 0.2s ease-in-out'
              }}
            >
              OK
            </button>
          </div>
        ) : (
          <form onSubmit={handleLoginRequest}>
            <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>
              登録済みのメールアドレスを入力してください。
            </p>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@example.com"
              style={inputStyle}
              required
              disabled={loading}
            />
            <button 
              type="submit" 
              disabled={loading}
              onMouseEnter={() => setIsHoverSubmit(true)}
              onMouseLeave={() => setIsHoverSubmit(false)}
              style={{ 
                ...buttonStyle, 
                backgroundColor: isHoverSubmit ? '#2b6cb0' : '#3182ce',
                color: 'white', // ← ここを白に修正しました！
                transition: 'background-color 0.2s ease-in-out'
              }}
            >
              {loading ? '送信中...' : '続行'}
            </button>
            
            {errorMsg && (
              <p style={{ color: '#e53e3e', fontSize: '0.9rem', textAlign: 'center', marginTop: '1rem', fontWeight: 'bold' }}>
                {errorMsg}
              </p>
            )}
          </form>
        )}
      </div>
    </div>
  );
}

export default function RootLoginPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LoginContent />
    </Suspense>
  );
}

const formStyle = { backgroundColor: 'white', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', width: '400px' };
const inputStyle = { width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #cbd5e0', boxSizing: 'border-box' as const, marginBottom: '1rem', outline: 'none' };
const buttonStyle = { width: '100%', padding: '0.8rem', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' };
